import Splide from '@splidejs/splide'

export function slider() {
	const resetSlider = (slider) => {
		const sliderList = slider.querySelector('.splide__list')
		const slides = slider.querySelectorAll('.splide__slide')

		if (slider) {
			slider.removeAttribute('aria-label')
			if (slider.getAttribute('title')) {
				slider.setAttribute('aria-label', slider.getAttribute('title'))
			}

			if (sliderList) {
				sliderList.removeAttribute('role') // Remove the invalid role
				sliderList.setAttribute('role', 'list') // Add a valid role
			}

			if (slides) {
				slides.forEach((slide) => {
					slide.removeAttribute('role')
					slide.setAttribute('role', 'listItem')
				})
			}
		}
	}

	const sliders = []
	let elms = document.querySelectorAll('.splide:not(.splide--facts)')

	for (let i = 0; i < elms.length; i++) {
		const slider = new Splide(elms[i], {
			keyboard: true
		})

		slider.on('ready', function () {
			resetSlider(slider.root)
		})

		sliders.push(slider.mount())
	}

	return sliders
}
